import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ModalDirective } from 'ngx-bootstrap';
import { AppConfigService } from '../../app.config';
import { DisplayModes } from '../../models/enums';
import { Permission } from '../../models/permission.model';
import { AccountService } from '../../services/account.service';
import { AlertService, MessageSeverity } from '../../services/alert.service'; 
import { AppTranslationService } from '../../services/app-translation.service';
import { CallRateCalculationsService } from './call-rate-calculations.service';

@Component({
  selector: 'crm-call-rate-calculations',
  templateUrl: './call-rate-calculations.component.html',
  styleUrls: ['./call-rate-calculations.component.css']
})
export class CallRateCalculationsComponent implements OnInit {

  callRateCalculations: any[] = [];
  displayMode: DisplayModes = DisplayModes.Success;
  searchText: string;
  pageSize: number;
  public logo = require("../../../app/assets/images/demo/Icon_Items Format.png");

  selectedId;
  addNew: boolean = false;
  @ViewChild('deleteModal')
  deleteModal: ModalDirective;


  
  constructor(private readonly router: Router,
    private readonly alertService: AlertService,
    private readonly translateService: AppTranslationService,
    private readonly appConfig: AppConfigService,
    private readonly callRateCalculationsService: CallRateCalculationsService,
    private accountService: AccountService) { }

  ngOnInit() {
    this.pageSize = this.appConfig.settings.pageSize;
    this.getCallRateCalculations();
  }

  getCallRateCalculations() {
    this.displayMode = DisplayModes.Loading;
    this.callRateCalculationsService.search().subscribe(responce => {
      this.callRateCalculations = responce as any[];
      this.displayMode = DisplayModes.Success;
    },
      err => {
        this.displayMode = DisplayModes.Error;
        console.log('error in get callRateCalculations');
        console.log(err);
      })

  }

  gotoNew() {
    this.addNew = true;
  }

  edit(id) {
    this.selectedId = id;
    this.addNew = true;
  }

  confirmDelete(item) {
    this.selectedId = item;
    this.deleteModal.show();
  }

  delete() {
    this.hideDeleteModal();
    this.displayMode = DisplayModes.Loading;
    this.callRateCalculationsService.delete(this.selectedId.id).subscribe(response => {
      this.displayMode = DisplayModes.Success;
      this.alertService.showMessage("", this.translateService.getTranslation("clm.deletedSuccessfully"), MessageSeverity.Success);

      let index = this.callRateCalculations.indexOf(this.selectedId);
      this.callRateCalculations.splice(index, 1);
    }, error => {
      this.displayMode = DisplayModes.Error;
      this.alertService.showStickyMessage("Save Error", "The below errors occured while delete item fromat:", MessageSeverity.Error, error);
      this.alertService.showStickyMessage(error, null, MessageSeverity.Error);
    });
  }

  get canManageCallRateCalculationsPermission() {
    return this.accountService.userHasPermission(Permission.manageCallRateCalculationsPermission);
  }

  closeAdding(event) {
    this.selectedId = undefined;
    this.addNew = false;
    if (event) {
      this.getCallRateCalculations();
    }
  }

  hideDeleteModal() {
    this.deleteModal.hide();
  }

  getTypeName(type) {
    if (type == 0)
      return "Total Visits";
    else if (type == 1)
      return "Hcp Visits Only";
    else if (type == 2)
      return "Field Days";
    else if (type == 3)
      return "Field Shifts";
    else if (type == 4)
      return "Fields Days Am";
    else if (type == 5)
      return "Fields Days Pm";
  }

}
